import {
    ACT_TYPE_LIST, ACT_TYPE_LIST_SUCCESS, ACT_TYPE_LIST_ERROR,
    ACT_TYPE_LIST_SEARCH_CHANGE, ACT_TYPE_LIST_PAGE_SET,
    ACT_TYPE_ADD_MODAL_SET, ACT_TYPE_ADD_CHANGE_SET,
    ACT_TYPE_ADD, ACT_TYPE_ADD_SUCCESS, ACT_TYPE_ADD_ERROR,
    ACT_TYPE_GET, ACT_TYPE_GET_SUCCESS, ACT_TYPE_GET_ERROR,
    ACT_TYPE_VIEW_MODAL_SET,
    ACT_TYPE_EDIT_MODAL_SET, ACT_TYPE_EDIT_CHANGE_SET,
    ACT_TYPE_EDIT, ACT_TYPE_EDIT_SUCCESS, ACT_TYPE_EDIT_ERROR
} from "../actions";

const INIT_STATE = {
    loading: false,
    list: { page: { current: 1, rows: 10 }, data: [], total_item: 0, total_pages: 0 },
    add: { data: {}, modal: false, loading: false, message: '', type: '' },
    detail: { data: {}, loading: false },
    view: { modal: false },
    edit: { data: { new: {}, old: {} }, modal: false, loading: false, update: { loading: false, response: '', message: '' } },
    error: false,
    search: { data: { name: '' } }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        // List
        case ACT_TYPE_LIST: return { ...state, loading: true };
        case ACT_TYPE_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
        case ACT_TYPE_LIST_ERROR: return { ...state, loading: false, error: true };
        case ACT_TYPE_LIST_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
        case ACT_TYPE_LIST_SEARCH_CHANGE: return { ...state, search: { ...state.search, data: action.payload } };

        // Add
        case ACT_TYPE_ADD_MODAL_SET: return { ...state, add: { ...state.add, modal: action.payload } };
        case ACT_TYPE_ADD_CHANGE_SET: return { ...state, add: { ...state.add, data: { ...state.add.data, ...action.payload } } };
        case ACT_TYPE_ADD: return { ...state, add: { ...state.add, loading: true } };
        case ACT_TYPE_ADD_SUCCESS: return { ...state, add: { ...state.add, modal: false, loading: false, ...action.payload }, list: { ...state.list, ...action.payload } };
        case ACT_TYPE_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, ...action.payload } };

        // Get (detail)
        case ACT_TYPE_GET: return { ...state, detail: { ...state.detail, loading: true, data: {} } };
        case ACT_TYPE_GET_SUCCESS: return {
            ...state,
            detail: { ...state.detail, loading: false, data: action.payload },
            edit: { ...state.edit, data: { new: { ...action.payload }, old: { ...action.payload } } }
        };
        case ACT_TYPE_GET_ERROR: return { ...state, detail: { ...state.detail, loading: false, data: {} } };

        // View
        case ACT_TYPE_VIEW_MODAL_SET: return { ...state, view: { ...state.view, modal: action.payload } };

        // Edit
        case ACT_TYPE_EDIT_MODAL_SET: return { ...state, edit: { ...state.edit, modal: action.payload } };
        case ACT_TYPE_EDIT_CHANGE_SET: return { ...state, edit: { ...state.edit, data: { ...state.edit.data, new: { ...state.edit.data.new, ...action.payload } } } };
        case ACT_TYPE_EDIT: return { ...state, edit: { ...state.edit, loading: true, update: { ...state.edit.update, loading: true, response: '', message: '' } } };
        case ACT_TYPE_EDIT_SUCCESS: return {
            ...state,
            edit: { ...state.edit, modal: false, loading: false, update: { loading: false, response: 'success', message: action.payload.message || '' } },
            view: { ...state.view, modal: false },
            list: { ...state.list, ...action.payload }
        };
        case ACT_TYPE_EDIT_ERROR: return { ...state, edit: { ...state.edit, loading: false, update: { loading: false, response: 'error', message: action.payload.message || '' } } };

        default: return { ...state };
    }
};
